import { render, staticRenderFns } from "./RNonCanonicalAlertCard.vue?vue&type=template&id=77f28737&scoped=true&"
import script from "./RNonCanonicalAlertCard.vue?vue&type=script&lang=js&"
export * from "./RNonCanonicalAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./RNonCanonicalAlertCard.vue?vue&type=style&index=0&id=77f28737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f28737",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
